import { useEffect } from "react";
import Histogram from "./Histogram";
import XModal from "../../../components/common/XModal";

const HistogramModal = ({ isOpen, onClose, title, subtitle, data, selectedDataKey, isLoading }) => {

    useEffect(() => {
        document.body.style.overflow = isOpen ? "hidden" : "auto";

        return () => {
            document.body.style.overflow = "auto";
        };
    }, [isOpen]);

    return (
        <XModal
            isOpen={isOpen}
            title={title}
            onClose={onClose}
            size="lg"
        >
            <h5 className="flex justify-center text-2xl font-semibold text-content">{subtitle}</h5>
            {isLoading ? (
                <div className="text-center py-6">Loading...</div>
            ) : (
                <Histogram selectedDataKey={selectedDataKey} data={data} />
            )}
        </XModal>
    );
};

export default HistogramModal;
